import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux'
import { persistStore, persistReducer } from 'redux-persist'
import localforage from 'localforage';
import reducers from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  blacklist: ['certificatesReducer'],
  storage: localforage,
}

const appReducer = reducers;

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_START') {
    const { routing } = state
    state = { routing } 
  }
  return appReducer(state, action)
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

export default function configureStore(history) {
  const RouterMiddleware = routerMiddleware(history)
  const middlewares = [ReduxThunk, RouterMiddleware];

  const store = createStore(
    persistedReducer,
    {},
    composeEnhancers(
      applyMiddleware(...middlewares),
    )
  );

  let persistor = persistStore(store)
  return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/store.js